import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewProfileLayer from "../components/ViewProfileLayer";
import { useParams } from "react-router-dom";


const ViewProfilePage = () => {
  const { id } = useParams();
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Profile" />

        {/* ViewProfileLayer */}
        <ViewProfileLayer key={id} />

      </MasterLayout>

    </>
  );
};

export default ViewProfilePage; 
